# Job ad preview

Your software can provide a preview of how a job ad will appear on SEEK.
This helps a hirer to spot issues prior to posting and provides them with confidence that their job ad will appropriately represent their position and organization.

import { Actions, ButtonLink, IconNewWindow } from 'braid-design-system';

<Actions>
  <ButtonLink
    href="https://job-ad-preview.seek.com/anzPublicTest?id=seekAnzPublicTest:postedPositionProfilePreview:seekApi:37EWfWxhwVEGTT5BcjfE2L"
    icon={<IconNewWindow />}
    size="small"
    target="_blank"
    tone="brandAccent"
  >
    Try it out
  </ButtonLink>
</Actions>

If you haven’t yet built this feature into your software,
check out the [previewing a job ad] documentation.

If previews are already available in your software,
we have seamlessly extended them to support our new [location] and [salary] options.
However, you should review two other changes to the [`postedPositionProfilePreview`] query:

1. [Ad selection]

   Once you have integrated our new panel or GraphQL query,
   omit the deprecated `seekAnzAdvertisementType` field in favour of a [`seekAdvertisementProductId`].

2. [Questionnaires]

   If your software integrates with SEEK questionnaires,
   the job ad page will display a summary of the questions posed by the hirer.
   Supply a [`seekApplicationQuestionnaireId`] for an accurate preview of the job ad.

[`postedpositionprofilepreview`]: /schema/query/postedPositionProfilePreview
[`seekadvertisementproductid`]: /schema/named-type/PostedPositionProfilePreview_PostingInstructionInput#/field/seekAdvertisementProductId
[`seekapplicationquestionnaireid`]: /schema/named-type/PostedPositionProfilePreview_PositionProfileInput#/field/seekApplicationQuestionnaireId
[ad selection]: /migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/ad-selection
[questionnaires]: /migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/questionnaires
[location]: /migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/locations
[previewing a job ad]: /use-cases/job-posting/managing-job-ads/previewing-a-job-ad
[salary]: /migration-guides/jobstreet-and-jobsdb-uplift/phase-2-job-posting/salary
